import React, { FC } from 'react';
import { Typography } from '@mui/material';
import Loading from './Loading';

type IProps = {
    loading: boolean;
    error: string;
    children?: any;
};

const LoadingContent: FC<IProps> = ({ loading, error, children }) => {
    return loading ? (
        <Loading />
    ) : error ? (
        <Typography
            sx={{
                textAlign: 'center',
                padding: '5rem 0',
            }}
            color="error"
        >
            {error}
        </Typography>
    ) : (
        children
    );
};

export default LoadingContent;
